import Vuex from "vuex";
import Vue from "vue";
import me from "./me";
import users from "./users";
import companies from "./companies";
import brandStories from "./brand-stories";
import reports from "./reports";
import analytics from "./analytics";
import smartVaultSearch from "./smart-vault-search";
import smartVaultProduct from "./smart-vault-product";
import purchaseOrders from "./purchase-orders";

let initialState = {
  users: { ...purchaseOrders.state }
};

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    me,
    users,
    companies,
    purchaseOrders,
    reports,
    analytics,
    smartVaultSearch,
    smartVaultProduct,
    brandStories
  },
  mutations: {
    reset() {
      store.replaceState(initialState);
    }
  }
});

export default store;
